export default function formatProductType(type, productType) {
  switch (type) {
    /**
     * category: 把商品類類型做分類
     */
    case 'category':
      const productTypeCategoryMap = {
        'light': 'light',
        'treasury': 'activity',
        'puja': 'activity',
        'pudu': 'activity',
        'worshipset': 'light',
      };

      return productTypeCategoryMap[productType];

    default:
      return 'need type'
  }
}
